export default {
  trainingLoaded(state) {
    return state.trainingLoaded;
  },
  enrollmentsLoaded(state) {
    return state.enrollmentsLoaded;
  },
  modules(state) {
    return state.modules;
  },
  learningContent(state) {
    return state.learningContent;
  },
  competencyTests(state) {
    return state.competencyTests;
  },
  enrollments(state) {
    return state.enrollments;
  },
  requiredActions(state) {
    return state.requiredActions;
  },
};
